// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"01f09be2","1400":"01f09be2","4959":"8f919402","9294":"70ebfca2"}[chunkId] + ".chunk.css";
};